"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isObjectType = void 0;
const isObjectType = function ({ type }) {
    return type === 'object';
};
exports.isObjectType = isObjectType;
